import React from 'react';
import { contact } from '../data/company';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

const rows = [
  ['building', 'Company', 'company'],
  ['pin', 'Office Address', 'address'],
  ['building', 'Head Office Address', 'headOffice'],
  ['phone', 'Phone', 'phone'],
  ['mail', 'Email', 'email'],
  ['clock', 'Business Hours', 'hours'],
];

export default function Contact() {
  return (
    <section id="contact" className="section section--alt">
      <div className="container contact">
        <div>
          <SectionHeading eyebrow="Contact" title="Let's talk about your project" text="Reach out and our team will get back to you." />
          <Reveal delay={80}>
            <ul className="contact__list">
              {rows.map(([icon, label, key]) => (
                <li key={key}>
                  <span className="contact__icon"><Icon name={icon} size={20} /></span>
                  <div><small>{label}</small><span>{contact[key]}</span></div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <Reveal delay={120} className="contact__map">
          {contact.mapEmbedUrl ? (
            <>
              <iframe title="SDL location" src={contact.mapEmbedUrl} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
              {contact.mapLink && (
                <a className="btn btn--primary contact__maplink" href={contact.mapLink} target="_blank" rel="noopener noreferrer">
                  Open in Google Maps <Icon name="arrow" size={16} />
                </a>
              )}
            </>
          ) : (
            <div className="contact__mapph">
              <Icon name="pin" size={36} />
              <strong>Map location</strong>
              <span>Add a Google Maps embed URL in <code>src/data/company.js</code></span>
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
